import {
  acceptRung,
  addDefinition,
  addRung,
  dropDefinition,
  dropRung,
  rewordDefinition,
  rewordRung,
} from "./framework-edits";
import type { Send } from "./section-actions";
import type { SectionActions } from "./SectionCard";

/**
 * What a subsection's child lines send, one line at a time: a Definitions line, or a rung of a
 * claim row's range ladder. Each is one change to the framework, made against the latest one.
 */
export function childActions(
  send: Send,
): Pick<SectionActions, "definitions" | "ladders"> {
  return {
    definitions: {
      add: (subsectionId, words, putBack) => {
        const id = crypto.randomUUID();
        send((edits) => addDefinition(edits, subsectionId, words, id), {
          putBack,
          control: "add definition",
        });
      },
      reword: (subsectionId, itemId, words, putBack) => {
        send((edits) => rewordDefinition(edits, subsectionId, itemId, words), {
          putBack,
          control: "definition",
        });
      },
      drop: (subsectionId, itemId) => {
        send((edits) => dropDefinition(edits, subsectionId, itemId), {
          control: "drop definition",
        });
      },
    },
    ladders: {
      accept: (subsectionId, ladder, itemId, accepted) => {
        send(
          (edits) => acceptRung(edits, subsectionId, ladder, itemId, accepted),
          { control: "accept rung" },
        );
      },
      reword: (subsectionId, ladder, itemId, key, putBack) => {
        send((edits) => rewordRung(edits, subsectionId, ladder, itemId, key), {
          putBack,
          control: "rung",
        });
      },
      add: (subsectionId, ladder, key, putBack) => {
        const id = crypto.randomUUID();
        send((edits) => addRung(edits, subsectionId, ladder, key, id), {
          putBack,
          control: "add rung",
        });
      },
      drop: (subsectionId, ladder, itemId) => {
        send((edits) => dropRung(edits, subsectionId, ladder, itemId), {
          control: "drop rung",
        });
      },
    },
  };
}
